import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { OOCPackageItemKeys } from '../../api/Constants';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import Screens from '../../screens';
import transformObjectResponseKeys from '../../utils/transformObjectResponseKeys';
import Logger from '../../lib/analytics/logger';
import initApp from '../../lib/load/initApp';
import audio from '../../utils/audio';
import { FE_SNEAK_PEEK } from '../../utils/featureFlags/constants';
import useFeatureFlags from '../../hooks/useFeatureFlags.js';
import { isEqual, isEmpty } from '../../utils/object';
import utils from '../../utils';
import ActionsInterface from '../../api/ActionCommandsInterface';
import Emitter from '../../services/EmitterService';
import { actionCommandHandler } from '../../api/ActionCommandsInterface/utils/actionCommandHandler';
import { EVENT_EMITTER_TYPE, PLATFORM } from '../../constants';
import getActiveRouteDescriptor from '../../utils/getActiveRouteDescriptor';
import { ACTION_COMMANDS_QUEUE, ACTION_COMMANDS_TYPE } from '../../api/ActionCommandsInterface/constants';
var INIT_APP_MIN_COOLDOWN = 3600;
var LobbyOverlay = /*#__PURE__*/function (_Component) {
  function LobbyOverlay() {
    var _this;
    _classCallCheck(this, LobbyOverlay);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LobbyOverlay, [].concat(args));
    _this.state = {
      loading: true,
      allModalsLoaded: false,
      actionCommandsFirstTime: true,
      modalsFirstTime: true,
      modalsLoaded: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Screens.CurrencySelector, false), Screens.FavouritesUnlocked, false), Screens.SneakPeekOnboarding, false), Screens.Shop, false)
    };
    _this.checkIfPurchaseResponse = function () {
      var modal = _this.props.modal;
      var currentModal = modal === null || modal === void 0 ? void 0 : modal.modal;
      if (utils.getPlatform() === PLATFORM.WEB && (currentModal === Screens.PurchaseSucceeded || currentModal === Screens.PurchaseFlow)) {
        return true;
      }
      return false;
    };
    _this._checkToCallInitApp = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(new Date().getDate() !== new Date(_this.props.lastInitApp).getDate())) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return _this.fetchInitApp();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    _this.fetchInitApp = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.t0 = _this.props.token;
            if (!_context2.t0) {
              _context2.next = 5;
              break;
            }
            _context2.next = 5;
            return initApp.bind(_this)();
          case 5:
            _context2.next = 10;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t1 = _context2["catch"](0);
            console.error(_context2.t1);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }));
    _this.handleOnLoadModals = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _this$props$onboardin;
      var _useFeatureFlags, hasFeature, _this$props, initAppResponse, initialModal, actionCommands, showTooltip, pendingMessages, claimPendingMessages, actionCommandsRunning, isHomeScreen, hasActionCommand, outOfCoinsResponse, promoLinks;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _useFeatureFlags = useFeatureFlags(), hasFeature = _useFeatureFlags.hasFeature;
            _this$props = _this.props, initAppResponse = _this$props.initAppResponse, initialModal = _this$props.initialModal, actionCommands = _this$props.actionCommands, showTooltip = _this$props.showTooltip, pendingMessages = _this$props.pendingMessages, claimPendingMessages = _this$props.claimPendingMessages;
            if (!(initialModal === Screens.PurchaseSucceeded || initialModal === Screens.PurchaseFlow)) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return");
          case 4:
            actionCommandsRunning = false;
            isHomeScreen = getActiveRouteDescriptor(_this.props).key === Screens.Home;
            hasActionCommand = actionCommands === null || actionCommands === void 0 ? void 0 : actionCommands.some(function (action) {
              return action.payload.screen === Screens.Home && (action.queue === ACTION_COMMANDS_QUEUE.ENTER_LOBBY_1 || action.queue === ACTION_COMMANDS_QUEUE.ENTER_LOBBY_2);
            });
            if (hasActionCommand || showTooltip) actionCommandsRunning = true;
            audio.pauseSfx();
            _this.setState({
              loading: false
            });

            //Link Account
            if (initAppResponse.SETTINGS) {
              _this.props.isAccountLinked(initAppResponse.SETTINGS.linkedCasinoId);
              _this.props.setCurrentMemberLevel(initAppResponse.CURRENT_MEMBER_LEVEL);
            }

            //Currency Selector
            if (!(initialModal === Screens.CurrencySelector && !actionCommandsRunning && !_this.state.modalsLoaded[initialModal])) {
              _context3.next = 14;
              break;
            }
            _context3.next = 14;
            return _this.openModal(initialModal);
          case 14:
            if (!(!actionCommandsRunning && isHomeScreen)) {
              _context3.next = 17;
              break;
            }
            _context3.next = 17;
            return _this._shouldShowFavouritesUnlockedOnboarding();
          case 17:
            if (!(hasFeature(FE_SNEAK_PEEK) && !actionCommandsRunning && initAppResponse.SNEAK_PEEK && !((_this$props$onboardin = _this.props.onboardingsSeen) !== null && _this$props$onboardin !== void 0 && _this$props$onboardin.includes(ONBOARDING_FLOWS.SNEAK_PEEK)) && !_this.state.modalsLoaded[Screens.SneakPeekOnboarding])) {
              _context3.next = 21;
              break;
            }
            _context3.next = 20;
            return _this.openModal(Screens.SneakPeekOnboarding);
          case 20:
            _this.props.markOnboardingSeen(ONBOARDING_FLOWS.SNEAK_PEEK);
          case 21:
            // Out_of_Coins
            if (initAppResponse.OUT_OF_COINS && !actionCommandsRunning) {
              outOfCoinsResponse = transformObjectResponseKeys(initAppResponse.OUT_OF_COINS, OOCPackageItemKeys);
              _this.props.setOutOfCoinOfferResponse(outOfCoinsResponse);
              _this.props.isOutOfCoinsPurchase(false);
            }

            /* Dev user */
            _this.props.setIsDevUser(initAppResponse.DEV_ACCOUNT === 'yes');
            if (actionCommandsRunning) {
              _context3.next = 26;
              break;
            }
            _context3.next = 26;
            return claimPendingMessages(pendingMessages, getActiveRouteDescriptor(_this.props).key);
          case 26:
            promoLinks = pendingMessages.filter(function (message) {
              return message.type === 'PROMO_LINK';
            });
            if (!(promoLinks.length > 0 && !promoLinks[0].active && !actionCommandsRunning && !_this.state.modalsLoaded[Screens.Shop])) {
              _context3.next = 31;
              break;
            }
            Logger.setActionTrigger('promoLink');
            _context3.next = 31;
            return _this.openModal(Screens.Shop);
          case 31:
            !actionCommandsRunning && isHomeScreen && _this.setState({
              allModalsLoaded: true
            });
          case 32:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    _this.openModal = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(modal) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this.setState({
                modalsLoaded: _objectSpread(_objectSpread({}, _this.state.modalsLoaded), {}, _defineProperty({}, modal, true))
              });
              _context4.next = 3;
              return QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, RouteParamConstants.PARAM_MODAL, modal));
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    _this.handleOnLoadActionsCommands = function (prevProps) {
      var _this$props2 = _this.props,
        actionCommands = _this$props2.actionCommands,
        updatedTerms = _this$props2.updatedTerms;
      var _this$state = _this.state,
        actionCommandsFirstTime = _this$state.actionCommandsFirstTime,
        allModalsLoaded = _this$state.allModalsLoaded;
      if (_this.checkIfPurchaseResponse()) return;
      var propsChanged = !isEqual(prevProps.actionCommands, actionCommands) || _this.checkScreenChange(prevProps) || actionCommandsFirstTime;
      var hasActionCommands = actionCommands.length > 0 && actionCommands.some(function (action) {
        return action.queue === ACTION_COMMANDS_QUEUE.ENTER_LOBBY_1 || action.queue === ACTION_COMMANDS_QUEUE.ENTER_LOBBY_2 || action.actionType === ACTION_COMMANDS_TYPE.NOTIFICATION;
      });
      var shouldHandleActionCommands = propsChanged && !updatedTerms && (hasActionCommands || allModalsLoaded);
      if (shouldHandleActionCommands) {
        _this.setState({
          actionCommandsFirstTime: false
        });
        ActionsInterface(_this.props);
      }
    };
    _this.checkScreenChange = function (prevProps) {
      var prevScreen = getActiveRouteDescriptor(prevProps).key;
      var currentScreen = getActiveRouteDescriptor(_this.props).key;
      return prevScreen !== currentScreen;
    };
    _this._shouldShowFavouritesUnlockedOnboarding = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var _this$props3, onboardingsSeen, userLevel, onboardingsUnlockLevels, favouriteGames;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _this$props3 = _this.props, onboardingsSeen = _this$props3.onboardingsSeen, userLevel = _this$props3.userLevel, onboardingsUnlockLevels = _this$props3.onboardingsUnlockLevels, favouriteGames = _this$props3.favouriteGames;
            if (!(!(onboardingsSeen !== null && onboardingsSeen !== void 0 && onboardingsSeen.includes(ONBOARDING_FLOWS.FAVOURITES)) && userLevel === onboardingsUnlockLevels[ONBOARDING_FLOWS.FAVOURITES] && favouriteGames.gameList.length === 0 && !_this.state.modalsLoaded[Screens.FavouritesUnlocked])) {
              _context5.next = 4;
              break;
            }
            _context5.next = 4;
            return _this.openModal(Screens.FavouritesUnlocked);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    _this._tooltipButtonClickHandler = function (buttonAction) {
      audio.onClick();
      QueryParamProxy.setQueryParams(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_MODAL, buttonAction.modal), RouteParamConstants.PARAM_SHOP_TYPE, buttonAction.type));
      _this.props.shouldShowTooltip(false);
    };
    _this._dismissModal = function () {
      _this.props.setModal(null);
      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
    };
    return _this;
  }
  _inherits(LobbyOverlay, _Component);
  return _createClass(LobbyOverlay, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this$props4, token, lastInitApp, initAppResponse;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this$props4 = this.props, token = _this$props4.token, lastInitApp = _this$props4.lastInitApp, initAppResponse = _this$props4.initAppResponse;
              if (token) {
                _context6.next = 3;
                break;
              }
              return _context6.abrupt("return");
            case 3:
              if (!(new Date().getTime() - lastInitApp > INIT_APP_MIN_COOLDOWN && isEmpty(initAppResponse))) {
                _context6.next = 8;
                break;
              }
              _context6.next = 6;
              return this.fetchInitApp(initAppResponse);
            case 6:
              _context6.next = 9;
              break;
            case 8:
              this.synchronizeLobby(this.props, this.state);
            case 9:
              this.setState({
                loading: false
              });
              Emitter.on(EVENT_EMITTER_TYPE.ACTION_COMMANDS, function (_ref6) {
                var actionType = _ref6.actionType,
                  data = _ref6.data;
                return actionType && actionCommandHandler[actionType](data);
              });
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Emitter.off(EVENT_EMITTER_TYPE.ACTION_COMMANDS);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!isEqual(prevProps, this.props)) this.synchronizeLobby(prevProps, prevState);
      if ((!isEqual(prevProps.initAppResponse, this.props.initAppResponse) || !isEqual(prevProps.actionCommands, this.props.actionCommands) || this.state.modalsFirstTime || this.checkScreenChange(prevProps)) && !this.state.allModalsLoaded) {
        this.setState({
          modalsFirstTime: false
        });
        this.handleOnLoadModals();
      }
      if (this.state.allModalsLoaded && this.props.pendingMessages.length > prevProps.pendingMessages.length) this.props.claimPendingMessages(this.props.pendingMessages, getActiveRouteDescriptor(this.props).key);
      this.handleOnLoadActionsCommands(prevProps);
    }
  }, {
    key: "synchronizeLobby",
    value: function () {
      var _synchronizeLobby = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(prevProps) {
        var _this$props5, navigation, descriptors, activeKey, descriptor, prevActiveKey, prevDescriptor, connectionLostModal, cheatMenuActive;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!this.props.device.isConnected) {
                _context7.next = 14;
                break;
              }
              _this$props5 = this.props, navigation = _this$props5.navigation, descriptors = _this$props5.descriptors;
              activeKey = navigation.state.routes[navigation.state.index].key;
              descriptor = descriptors[activeKey];
              prevActiveKey = prevProps.navigation.state.routes[prevProps.navigation.state.index].key;
              prevDescriptor = prevProps.descriptors[prevActiveKey]; // coming back from a 'not connected' error?
              connectionLostModal = QueryParamProxy.findParam(RouteParamConstants.PARAM_MODAL, false); // coming from the cheat menu?
              cheatMenuActive = QueryParamProxy.findParam(RouteParamConstants.PARAM_CHEAT_MENU_ACTIVE, false);
              if (connectionLostModal === Screens.ConnectionLost && !cheatMenuActive) {
                QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
              }
              if (!(prevDescriptor.key != Screens.Home && prevDescriptor.key != descriptor.key)) {
                _context7.next = 12;
                break;
              }
              _context7.next = 12;
              return this._shouldShowFavouritesUnlockedOnboarding();
            case 12:
              _context7.next = 15;
              break;
            case 14:
              // need to inform the user that the connection has been lost
              QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.ConnectionLost));
            case 15:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function synchronizeLobby(_x2) {
        return _synchronizeLobby.apply(this, arguments);
      }
      return synchronizeLobby;
    }()
  }, {
    key: "render",
    value: function render() {
      return this.props.render(_objectSpread(_objectSpread({}, this.props), {}, {
        descriptor: getActiveRouteDescriptor(this.props),
        loading: this.state.loading,
        modal: this.props.modal.modal ? this.props.modal.modal : null,
        dismissModal: this._dismissModal,
        tooltipButtonClickHandler: this._tooltipButtonClickHandler,
        checkToCallInitApp: this._checkToCallInitApp
      }));
    }
  }]);
}(Component);
export { LobbyOverlay as default };